export const NO_EXTERNAL_CONNECTION_TEXT = "No external connection";
